import { useLang } from '../i18n'
import type { SlideImportTemplate } from '../lib/api'
import { navigate, templateViewPath } from '../lib/router'
import { keptTemplateWords } from '../lib/slide-import'

/**
 * What "Keep source formatting" did with a deck's masters (AB#483), as the import dialog's end and a
 * job's details both say it, with a link to the template's view. `onOpen` leaves whatever shows it.
 */
export function KeptTemplateLine({ bid, template, onOpen }: { bid: string; template: SlideImportTemplate; onOpen: () => void }) {
  const { t } = useLang()
  const path = templateViewPath(bid, template.id)
  const { key, vars } = keptTemplateWords(template)
  const words = Object.entries(vars ?? {}).reduce((acc, [k, v]) => acc.replaceAll(`{${k}}`, () => String(v)), t(key))
  return (
    <p className="pptx-kept">
      {words}{' '}
      <a
        className="jobs-details"
        href={path}
        onClick={(e) => {
          e.preventDefault()
          onOpen()
          navigate(path)
        }}
      >
        {t('pptx_kept_open')}
      </a>
    </p>
  )
}
